/**
 * Printing & photocopy is a service ordered from a shop's page, not a product listing,
 * so its category tile goes to /print (the print-shop list) instead of /category/<slug>.
 */
const PRINT_CATEGORY = /print|photocop|xerox/i;

export const PRINT_CATEGORY_LINK = '/print';

export function isPrintCategory(cat: { name?: string; slug?: string } | null | undefined): boolean {
  return !!cat && (PRINT_CATEGORY.test(cat.slug || '') || PRINT_CATEGORY.test(cat.name || ''));
}

/** routerLink for a category tile. */
export function categoryLink(cat: { name?: string; slug?: string }): string | string[] {
  return isPrintCategory(cat) ? PRINT_CATEGORY_LINK : ['/category', cat.slug || ''];
}
